// extracted by mini-css-extract-plugin
module.exports = {"row":"CourseLicenseTemplateRow_row_3-MGw","textOverflowEllipsis":"CourseLicenseTemplateRow_textOverflowEllipsis_2eFq8"};